export default __webpack_public_path__ + "static/media/learning.5acb833c.png";